module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAKklEQVQ4y2NgGBwgaPJ/ZPzvNAMYo4tj4GFkAEwDqZh6BozGAjUMGNIAAJMVTDDj3edbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/SE.png
// module id = 1259
// module chunks = 0